import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
function AdminStats() {
  const [stats, setStats] = useState({ statsByPeriod: [] });
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem('token');

  const API = process.env.REACT_APP_API;
  useEffect(() => {
    const fetchAllStats = async () => {
      try {
        const response = await fetch(`${API}/admin/stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const regularData = await response.json();
        setStats(regularData);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllStats();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='m-4 p-4'>
      <Table bordered hover variant="dark">
        <thead>
          <tr>
            <th style={{backgroundColor: 'black'}}>Date</th>
            <th style={{backgroundColor: 'black'}}>Profit</th>
          </tr>
        </thead>
        <tbody>
          {stats.statsByPeriod
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((period, index) => (
              <tr key={index}>
                <td>{new Date(period.date).toISOString().split('T')[0]}</td>
                <td>{Math.round(period.profit)} Birr</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}

export default AdminStats;
